import { render, staticRenderFns } from "./Save.vue?vue&type=template&id=5519cdfd&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"
import style0 from "./styles/save.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/index.css?vue&type=style&index=1&id=5519cdfd&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519cdfd",
  null
  
)

export default component.exports